import React from 'react';
import { useSelector } from "react-redux";
import { NavLink } from 'react-router-dom';
import './profileSection.scss';
import Button from '@material-ui/core/Button';
import CUserImageIcon from '../../CUserImageIcon';
import { useIsPremiumUser } from "examsbook-react-sdk/custom-hooks";
import { useNavigate } from "react-router-dom";
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";

function ProfileSection(props) {
    const user = useSelector((state) => state.user);
    const t = useTranslations();
    let imageUrl;
    if (user.image) {
        imageUrl = user.image.thumbnail.webP;
    }
    const isPremium = useIsPremiumUser();
    const navigate = useNavigate();
    const currentDate = new Date().toISOString();
    const expieryDate = user.premiumExpiry;
    const appSettings = useSelector((state) => state.appSettings);
    const isPaymentEnabled = !!appSettings.paymentEnabled;
    const diff = Math.floor((Date.parse(expieryDate) - Date.parse(currentDate)) / 86400000);
    return (
        <div>
            {
                user && user._id ?
                    <div className="profile-section">
                        <div className="profile-details">
                            <CUserImageIcon alt={imageUrl} src={imageUrl}/>
                            <NavLink to="/my-app/settings">
                                <Button className="settings-btn">
                                    <i className="fa fa-pencil"/>
                                </Button>
                            </NavLink>
                            <div className="user">
                                <h5>{user.name}</h5>
                                {
                                    isPaymentEnabled && <span>{
                                        isPremium && (diff <= 7) ? <Button className="renew-plan"
                                                                           onClick={() => navigate('/my-app/payments')}>{t('RENEW_VIP')}</Button>
                                            : isPremium ? <Button className="header-plan">{t('VIP')}</Button>
                                                : <Button className="header-become-plan"
                                                          onClick={() => navigate('/my-app/payments')}>{t('GET_VIP')}</Button>
                                    }
                                </span>
                                }
                                <span>{user.email}</span>
                            </div>
                            <div className="user user-contact">
                                <span>{user.city}</span>
                            </div>
                            {user.mobileNumber ?
                                <div className="user user-contact">
                                    <span>{user.mobileNumber}</span>
                                </div> : null}


                        </div>
                    </div> : null}
        </div>
    );
}

export default ProfileSection;
